import { render } from "./MediathequePoste.vue?vue&type=template&id=3c81b2c2&ts=true"
import script from "./MediathequePoste.vue?vue&type=script&lang=ts"
export * from "./MediathequePoste.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__